import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Header } from '@/components/layout/Header';
import { NavDrawer, DRAWER_WIDTH, DRAWER_WIDTH_COLLAPSED } from '@/components/layout/NavDrawer';
import { useSidebar } from '@/hooks/useSidebar';

export function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { collapsed } = useSidebar();
  const drawerWidth = collapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Box className="no-print">
        <Header onMenuClick={() => setMobileOpen(true)} />
      </Box>
      <Box className="no-print">
        <NavDrawer mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { md: `calc(100% - ${drawerWidth}px)` },
          minWidth: 0,
          transition: (theme) => theme.transitions.create('width'),
        }}
      >
        <Toolbar />
        <Box sx={{ padding: { xs: 2, sm: 2.5, md: 3 } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
